<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col>
          <v-card>
            <v-card-title class="max-width-25per pr-0">
              <v-spacer></v-spacer>
              Project Management:
            </v-card-title>
              <v-data-table
                dense
                hide-default-header
                :headers="headers"
                :items="adminProjectManagementSettingsItems"
                class="max-width-50vw border-thin mx-25per mt-8"
                :items-per-page="-1"
                hide-default-footer
              >
                <template v-slot:[`item.Name`]="{ item }">
                    <span class="subtitle-1"> {{ item.Name }} </span>
                </template>
                <template v-slot:[`item.Actions`]="{ item }">
                  <v-btn color="primary" outlined small @click="manageClick(item)">Manage</v-btn>
                </template>
              </v-data-table>
            <v-card-text>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <MetricEditor
      v-if="metricEditorDialog"
      v-model="metricEditorDialog"
    />
    <MetricsManager
      v-if="HRorFinancierRole"
      v-model="metricManagerDialog"
    />
    <KeyPerformanceIndicator
      v-if="HRorFinancierRole"
      v-model="KeyPerformanceIndicatorDialog"
    />
    <EmployeeProjectsLabels
      v-if="PMorFinancierRole"
      v-model="employeeProjectsLabelsDialog"
    />
  </div>
</template>
<script>
import { getApiErrorMessage } from '@/utils/apiError'

export default {
  name: 'AdminProjectManagement',
  components: {
    MetricEditor: () => import('@/components/metrics/MetricEditor.vue'),
    MetricsManager: () => import('@/components/metrics/MetricsManager.vue'),
    KeyPerformanceIndicator: () => import('@/components/kpi/KeyPerformanceIndicator.vue'),
    EmployeeProjectsLabels: () => import('@/components/global/EmployeeProjectsLabels.vue')
  },
  data () {
    return {
      rolesOfCurrentUser: [],
      headers: [
        {
          text: 'Name',
          value: 'Name',
          class: 'px-2 text-no-wrap',
          width: '90%'
        },
        {
          text: '',
          value: 'Actions',
          class: 'px-2 text-no-wrap',
          width: '10%',
          align: 'right'
        }
      ],
      adminProjectManagementSettingsItems: [
        { Name: 'Metrics' },
        { Name: 'Employee Projects Labels' },
        { Name: 'KPI Selectors' }
      ],
      metricEditorDialog: false,
      metricManagerDialog: false,
      KeyPerformanceIndicatorDialog: false,
      employeeProjectsLabelsDialog: false
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    HRorFinancierRole () {
      let res = false
      for (let i = 0; i < this.rolesOfCurrentUser.length; i++) {
        if (this.rolesOfCurrentUser[i].RoleName === 'HR' || this.rolesOfCurrentUser[i].RoleName === 'financier') {
          res = true
          break
        }
      }
      return res
    },
    HRorManagerorFinancierRole () {
      let res = false
      for (let i = 0; i < this.rolesOfCurrentUser.length; i++) {
        if (this.rolesOfCurrentUser[i].RoleName === 'HR' ||
            this.rolesOfCurrentUser[i].RoleName === 'manager' ||
            this.rolesOfCurrentUser[i].RoleName === 'financier') {
          res = true
          break
        }
      }
      return res
    },
    PMorFinancierRole () {
      let res = false
      for (let i = 0; i < this.rolesOfCurrentUser.length; i++) {
        if (this.rolesOfCurrentUser[i].RoleName === 'manager' || this.rolesOfCurrentUser[i].RoleName === 'financier') {
          res = true
          break
        }
      }
      return res
    }
  },
  mounted () {
    if (!this.rolesOfCurrentUser.length) {
      this.getRolesOfCurrentUser()
    }
  },
  methods: {
    getRolesOfCurrentUser () {
      this.axios.get('/api/employee_role/' + this.user.login, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(result => {
        this.rolesOfCurrentUser = result.data
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    manageClick (item) {
      switch (item.Name) {
        case 'Metrics' :
          this.metricManagerDialog = true
          break
        case 'KPI Selectors' :
          this.KeyPerformanceIndicatorDialog = true
          break
        case 'Employee Projects Labels' :
          this.employeeProjectsLabelsDialog = true
          break
      }
    }
  }
}
</script>
<style lang="scss">
  .max-width-50vw {
    max-width: 50vw;
  }
  .border-thin {
    border: thin solid #9e9e9e
  }
  .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > td:not(.v-data-table__mobile-row) {
    border-bottom: thin solid #9e9e9e
  }
  .mx-25per {
    margin-left: 25%;
    margin-right: 25%;
  }
  .vh-80 {
    height: 80vh;
  }
  tr {
    height: 40px !important;
  }
  .max-width-25per {
    max-width: 25%;
  }
</style>
